import axios from "axios";

export async function getOwnedNFTs(address: string) {
  const baseURL = `${process.env.REACT_APP_ALCHEMY_URL}/getNFTs/`;

  return axios
    .get(baseURL, { params: { owner: address, contractAddresses: [process.env.REACT_APP_NFT_CONTRACT_ADDRESS] } })
    .then(response => response.data);
}
